import React, { useEffect } from "react";
import { getChatHistoryAISummary } from "../../../api/session-api";
import { Text, View, ProgressCircle } from "@adobe/react-spectrum";
import "./style.css";

interface ChatSummaryProps {
  activeChatId: string;
  type?: "chat" | "call";
}

const ChatSummary: React.FC<ChatSummaryProps> = ({
  activeChatId,
  type = "chat",
}) => {
  const [chatSummary, setChatSummary] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    if (!activeChatId) return;

    let isMounted = true;

    const fetchChatSummary = async () => {
      setLoading(true);
      try {
        const response = await getChatHistoryAISummary(activeChatId);
        if (isMounted) {
          setChatSummary(
            response.length === 0
              ? `No summary available for this ${type}.`
              : response.summary
          );
        }
      } catch (error) {
        if (isMounted) {
          setChatSummary(`Failed to fetch ${type} summary. Please try again.`);
        }
        console.error(`Error fetching ${type} summary:`, error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchChatSummary();

    return () => {
      isMounted = false;
    };
  }, [activeChatId]);

  return (
    <View UNSAFE_className="chat-summary-container">
      {loading ? (
        <ProgressCircle
          aria-label="Loading summary"
          isIndeterminate
          size="M"
          UNSAFE_className="chat-summary-progress"
        />
      ) : (
        <View UNSAFE_className="chat-summary-content">
          <Text>{chatSummary}</Text>
        </View>
      )}
    </View>
  );
};

export default ChatSummary;
